import { useEffect, useRef } from 'react';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';

const TextEditor = ({ setContent, content, placeholder }) => {
  const quillRef = useRef(null);

  const modules = {
    toolbar: [
      [{ font: [] }],
      [{ header: [1, 2, 3, 4, 5, 6, false] }],
      ['bold', 'italic', 'underline', 'strike'],
      [{ list: "ordered" }, { list: "bullet" }],
      [{ script: "sub" }, { script: "super" }],
      [{ color: [] }, { background: [] }],
      [{ align: [] }],
      ['link'],
      ['clean']
    ]
  };

  const handleChange = (html) => {
    setContent(html);
  };

  return (
    <div className="editor-container">
      <ReactQuill
        value={content}
        onChange={handleChange}
        modules={modules}
        theme="snow"
        placeholder={placeholder || "Message"}
        style={{ height: "150px", backgroundColor: "white" }}
      />
    </div>
  );

};

export default TextEditor;
